import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Products() {
    const [products, setProducts] = useState([]);
    const [newProduct, setNewProduct] = useState({ name: '', category: '', unit: '', price: 0, stock: 0 });

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/products`);
            setProducts(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddProduct = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${getApiUrl()}/products`, newProduct);
            setNewProduct({ name: '', category: '', unit: '', price: 0, stock: 0 });
            fetchProducts();
        } catch (err) {
            console.error(err);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${getApiUrl()}/products/${id}`);
            fetchProducts();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Products</h2>
                <form onSubmit={handleAddProduct} className="mb-4">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Product Name" value={newProduct.name} onChange={e => setNewProduct({...newProduct, name: e.target.value})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-2">
                            <input type="text" className="form-control" placeholder="Category" value={newProduct.category} onChange={e => setNewProduct({...newProduct, category: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-2">
                            <input type="text" className="form-control" placeholder="Unit" value={newProduct.unit} onChange={e => setNewProduct({...newProduct, unit: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-2">
                            <input type="number" className="form-control" placeholder="Price" value={newProduct.price} onChange={e => setNewProduct({...newProduct, price: parseFloat(e.target.value)})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-2">
                            <input type="number" className="form-control" placeholder="Stock" value={newProduct.stock} onChange={e => setNewProduct({...newProduct, stock: parseInt(e.target.value)})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-1 d-grid">
                            <button type="submit" className="btn btn-primary">Add</button>
                        </div>
                    </div>
                </form>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Category</th>
                                <th>Unit</th>
                                <th>Price</th>
                                <th>Stock</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map(p => (
                                <tr key={p.id}>
                                    <td>{p.name}</td>
                                    <td>{p.category}</td>
                                    <td>{p.unit}</td>
                                    <td>{p.price}</td>
                                    <td>{p.stock}</td>
                                    <td>
                                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(p.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
}

export default Products;
